// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YQDWj93Cb6S6VCrzodd9 {
    margin-bottom: 0.75rem;
    height: auto;
    width: 100%;
    border-radius: 0.5rem;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));
    padding: 1rem
}
.DDqEnTzauahk9T0PB3EI {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between
}
.i8q_I6l4T_A4PAnlaJYr {
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 600
}
.ZIaEI8FmKp4YzsmGz01L {
    margin-top: 1.25rem;
    display: flex;
    height: auto;
    width: 100%;
    flex-direction: column;
    gap: 1.25rem;
    font-family: Noto Sans
}
`, "",{"version":3,"sources":["webpack://./src/components/PriceSummaryModal/VoucherModal/VoucherModalList.module.css"],"names":[],"mappings":"AACE;IAAA,sBAA6E;IAA7E,YAA6E;IAA7E,WAA6E;IAA7E,qBAA6E;IAA7E,4DAA6E;IAA7E,kBAA6E;IAA7E,4DAA6E;IAA7E;AAA6E;AAG7E;IAAA,aAA+C;IAA/C,WAA+C;IAA/C,mBAA+C;IAA/C;AAA+C;AAG/C;IAAA,sBAA2C;IAA3C,eAA2C;IAA3C;AAA2C;AAG3C;IAAA,mBAAwD;IAAxD,aAAwD;IAAxD,YAAwD;IAAxD,WAAwD;IAAxD,sBAAwD;IAAxD,YAAwD;IAAxD;AAAwD","sourcesContent":[".voucherSection {\n  @apply w-full h-auto rounded-lg bg-layoutBackground p-4 mb-3 bg-tableExpandBG;\n}\n.promotionSectionHeader {\n  @apply w-full flex justify-between items-center;\n}\n.promotionSectionTitle {\n  @apply text-[14px] font-semibold font-inter;\n}\n.mainContainer {\n  @apply w-full mt-5 h-auto flex flex-col gap-5 font-inter;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voucherSection": `YQDWj93Cb6S6VCrzodd9`,
	"promotionSectionHeader": `DDqEnTzauahk9T0PB3EI`,
	"promotionSectionTitle": `i8q_I6l4T_A4PAnlaJYr`,
	"mainContainer": `ZIaEI8FmKp4YzsmGz01L`
};
export default ___CSS_LOADER_EXPORT___;
